import { render, staticRenderFns } from "./ProcessCommissions.vue?vue&type=template&id=0fb54a92&scoped=true&"
import script from "./ProcessCommissions.vue?vue&type=script&lang=js&"
export * from "./ProcessCommissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb54a92",
  null
  
)

export default component.exports